module.exports = __webpack_public_path__ + "img/icon-add.42e382a5.svg";